import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { pendingOwners, retryOwner, runOwner, type PendingOwner } from '@/lib/forex-owner-coordinator';

export default function OwnerPendingHost() {
  const { pathname } = useLocation();
  const [rows, setRows] = useState<PendingOwner[]>([]);
  useEffect(() => {
    const refresh = () => setRows([...pendingOwners()]);
    const tick = () => { for (const row of pendingOwners()) void runOwner(row); refresh(); };
    refresh();
    const timer = window.setInterval(tick, 1000);
    window.addEventListener('forex-owner-pending', refresh);
    return () => { clearInterval(timer); window.removeEventListener('forex-owner-pending', refresh); };
  }, []);
  if (!pathname.startsWith('/forex') || !rows.length) return null;
  return <aside aria-label="统计团队保存状态" className="fixed bottom-4 right-4 z-50 max-w-md rounded border bg-white p-3 shadow text-sm">
    {rows.map(row => <div key={row.assignmentKey} role="status" className="py-1">
      <p>{row.agentId ? `智能体 ${row.agentId.slice(0, 8)}` : '智能体创建记录'} · {row.error || '正在保存统计团队'}</p>
      {row.attempts >= 4 && <button className="text-brand underline" onClick={() => retryOwner(row)}>重试统计保存</button>}
    </div>)}
  </aside>;
}
